import React, { useContext, useState } from 'react';
import { Button, Intent } from '@blueprintjs/core';
import { ApiContext } from '../App';

import gapi from './gapi';
import DarkModeSelector from '../nav/DarkModeSelector';

const clientId = '695423755945-vbvumqp6345h0suto3nkvot7pincbhoi.apps.googleusercontent.com';
const scopes =
  'https://www.googleapis.com/auth/calendar.readonly email https://www.googleapis.com/auth/directory.readonly https://www.googleapis.com/auth/spreadsheets.readonly https://www.googleapis.com/auth/drive.readonly';
const discoveryDocs = [
  'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest',
  'https://people.googleapis.com/$discovery/rest?version=v1',
  'https://sheets.googleapis.com/$discovery/rest?version=v4',
  'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'
];
const apiKey = 'AIzaSyAD2mbfJNHQh2Ehh9_wQP64hvq5H3rJdEM';

/** Return login and logout elements for the app */
function Login() {
  const { loggedIn, setLoggedIn } = useContext(ApiContext);
  const [hasInitialized, setInitialized] = useState();

  const updateSigninStatus = (isSignedIn) => {
    setLoggedIn(isSignedIn);
  };

  const initClient = () => {
    gapi.client
      .init({
        discoveryDocs,
        clientId,
        scope: scopes,
        apiKey
      })
      .then(function () {
        // Listen for sign-in state changes.
        gapi.auth2.getAuthInstance().isSignedIn.listen(updateSigninStatus);
        setInitialized(true);

        // Handle the initial sign-in state.
        updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
      });
  };

  gapi.load('client:auth2', initClient);

  const handleAuthClick = (event) => {
    gapi.auth2.getAuthInstance().signIn();
  };

  if (loggedIn) {
    return null;
  }

  return (
    <>
      <div className="dst-login-padding">
        <div style={{ padding: '10px' }}>
          <DarkModeSelector />
        </div>
      </div>
      <div className="dst-login">
        <div className="dst-login-input">
          {!loggedIn && hasInitialized ? (
            <Button
              id="authorize-button"
              style={{ display: 'block' }}
              onClick={handleAuthClick}
              intent={Intent.PRIMARY}
            >
              Kirjaudu Google-tilillä
            </Button>
          ) : null}
        </div>
      </div>
    </>
  );
}

export default Login;
